import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useCartState } from 'supplier-portals/uxbeauty/contexts/cart/CartContext';

export const EmptyCart = () => {
  const { setDrawerOpen } = useCartState();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        gap: 1,
        py: 10,
        px: 3
      }}
    >
      <Typography
        variant="body1"
        sx={theme => ({
          color: theme.palette.primary.light,
          textTransform: 'uppercase'
        })}
      >
        Your cart is empty
      </Typography>
      <Typography sx={theme => ({ color: theme.palette.primary.light })}>
        You have not added any sample to your cart.
        <br /> Go ahead and search for ingredients and concepts to request
        samples.
      </Typography>

      <Button
        variant="contained"
        sx={{ mt: 4 }}
        component={Link}
        to="/ingredients/search"
        onClick={() => setDrawerOpen(false)}
      >
        Our ingredients
      </Button>
    </Box>
  );
};
